import { styled } from "@mui/material/styles";
import { Tab, Tabs } from "@mui/material";

const StyledTabs = styled(Tabs)`
  & .MuiTabs-flexContainer {
    gap: 16px;
  }

  & .MuiTabs-indicator {
    border-radius: 20px 20px 0 0;
    height: 3px;
  }

  &.tabs_blue {
    & .MuiTabs-indicator {
      background-color: ${({ theme }) => theme.palette.blue.main};
    }
  }
`;

const StyledTab = styled(Tab)<{ color?: string }>`
  padding: 0;
  min-width: max-content;

  &.Mui-selected {
    & .tab__label {
      font-weight: 500;
    }
  }

  &.Mui-disabled {
    & .tab__label {
      color: ${({ theme }) => theme.palette.customGrey.main};
    }
  }
`;

const StyledTabLabelContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const StyledTabMarker = styled("span")`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 5px;
  transform: translateY(-10px);
  background-color: ${({ theme }) => theme.palette.red.main};
`;

export { StyledTabs, StyledTab, StyledTabLabelContainer, StyledTabMarker };
